module.exports = __webpack_public_path__ + "img/lab1.9e9e7180.png";